import { render } from "./header-title.vue?vue&type=template&id=3ba2a7dd"
import script from "./header-title.vue?vue&type=script&setup=true&lang=js"
export * from "./header-title.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/linker-marketplace-web/linker-marketplace-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/v2/modules/orders/pages/order-details/components/header-title.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3ba2a7dd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3ba2a7dd', __exports__)) {
    console.log('reload')
    api.reload('3ba2a7dd', __exports__)
  }
  
  module.hot.accept("./header-title.vue?vue&type=template&id=3ba2a7dd", () => {
    console.log('re-render')
    api.rerender('3ba2a7dd', render)
  })

}


export default __exports__